/**
 * Metric keys whose comparison value is a percentage. TELV1-575.
 *
 * Shared because the statistical table is rendered TWICE — on screen in
 * ComparisonReport and again in the markdown download via
 * formatComparisonExport. Two copies of this list drift the moment a metric
 * is added, and the two surfaces would then disagree. PR review.
 *
 * Counts (completed_interviews, started_interviews) must stay bare, so this
 * is an explicit list rather than a default.
 */
export const PERCENTAGE_METRIC_KEYS = new Set(['completion_rate_pct', 'screening_pass_rate_pct']);

export const isPercentageMetric = (metricKey?: string) =>
  !!metricKey && PERCENTAGE_METRIC_KEYS.has(metricKey);

/**
 * Metric keys whose comparison value is a duration in MILLISECONDS.
 * TELV1-581.
 *
 * Only the `_ms` keys. The legacy `average_time_min` / `median_time_min` on
 * comparisons persisted before that change are rounded to whole minutes, so
 * they stay bare — formatting them as a duration would present a lossy value
 * as an exact one.
 */
export const DURATION_METRIC_KEYS = new Set(['average_time_ms', 'median_time_ms']);

export const isDurationMetric = (metricKey?: string) =>
  !!metricKey && DURATION_METRIC_KEYS.has(metricKey);
